<template>
  <div class="project-list-item">
    <img :src="icon" class="logo" />
    <div class="meta">
      <div class="title">
        <router-link :to="route" class="name">{{ title }}</router-link>
        <div class="code">{{ code }}</div>
      </div>
      <div class="location">{{ type }}</div>
      <div class="type">เปิดให้บริการอยู่ทั้งหมด {{ serviceCount }} บริการ</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    code: {
      type: null,
      default: undefined,
    },
    title: {
      type: null,
      default: undefined,
    },
    icon: {
      type: null,
      default: undefined,
    },
    type: {
      type: null,
      default: undefined,
    },
    serviceCount: {
      type: null,
      default: undefined,
    },
    route: {
      type: null,
      default: undefined,
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.project-list-item {
  display: grid;
  grid-template-columns: 64px 1fr;
  grid-gap: 30px;
  border-bottom: $border;
  padding: 15px 0;

  .logo {
    width: 64px;
    height: 64px;
    margin-top: 4px;
    border: $border;
    border-radius: 8px;
    object-fit: contain;
  }

  .meta {
    line-height: 1.6;
  }

  .code {
    text-align: right;
  }

  .title {
    display: grid;
    grid-template-columns: 1fr 120px;
    font-size: 16px;
  }

  .name {
    font-weight: bold;
  }

  .location,
  .type {
    font-size: 14px;
  }
}
</style>
